import Autoplay from "embla-carousel-autoplay";
import { motion } from "framer-motion";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import { ArticleType } from "~/interface/article/article";
import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_URL, LANG } from "~/utils/constant";
import ClientOnly from "../shared-components/ClentOnly";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import { useLanguageParams } from "~/hook/useLanguageParams";

type PropsType = {
  data: ArticleType[];
};

const Announcements = memo(({ data }: PropsType) => {
  const { t } = useTranslation();
  const { medium, normalInter } = useFontStyle();
  const lang = useLanguageParams();
  const isGujarati = lang === LANG.gujarati;

  const AnnouncementCard = (
    <div className="w-full flex flex-col justify-center items-center px-3 md:px-0 gap-btw-text-and-content  ">
      <motion.div className="w-full flex flex-col justify-center items-center gap_btw_title_content ">
        <p className={cn(isGujarati ? "home-page-heading-mar-guj" : "home-page-heading", medium)}>
          {t("home.announcements", { defaultValue: "Community Announcements" })}
        </p>
        <span className={cn("sub_desc_text_color body_text_l text-center title_para_width ", normalInter)}>
          {t("home.announcementDescription", {
            defaultValue: "Explore details about future Utsav, celebrations and upcoming publications releases.",
          })}
        </span>
      </motion.div>

      <motion.div className="w-full md:w-[70%] flex flex-col md:flex-row justify-center items-center md:justify-start md:items-start gap-8 bg-white rounded-lg cursor-pointer select-none">
        <Carousel
          opts={{
            align: "start",
            loop: true,
            dragFree: true,
            containScroll: "trimSnaps",
          }}
          plugins={[
            Autoplay({
              delay: 3000,
            }),
          ]}
          className="w-full"
        >
          <CarouselContent>
            {data?.map((announcement) => (
              <CarouselItem key={announcement.id} className="flex">
                <div className="w-full md:w-[50%] h-full aspect-video bg-red-300 rounded-md overflow-hidden">
                  <img
                    src={announcement?.img?.hd.url || FALLBACK_IMAGE_URL}
                    alt={announcement.title || "announcement"}
                    className="w-full h-full object-cover select-none !rounded-l-lg "
                  />
                </div>
                <div className="w-full flex flex-col justify-center p-6 items-center text-left md:justify-start md:items-start">
                  <span className={cn("text-textColor body_text_m font-medium line-clamp-2 md:line-clamp-4", medium)}>
                    {announcement.title || ""}
                  </span>
                  <span
                    className={cn("hidden md:block text-textSecondaryColor body_text_m font-normal line-clamp-2 md:line-clamp-4 ", normalInter)}
                    dangerouslySetInnerHTML={{ __html: announcement.description || announcement.meta_desc || "" }}
                  ></span>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </motion.div>
    </div>
  );

  return <ClientOnly fallback={AnnouncementCard}>{AnnouncementCard}</ClientOnly>;
});

export default Announcements;
